module.exports = __webpack_public_path__ + "Icono_Complemento-Ngr_126px.png";